import { getService } from 'data/function';
export class MediaProcessor {
    static get ApplicationService2() {
        return getService('ApplicationService2');
    }
    /**
     * Process media event from iframe
     * @param action
     */
    static async process({ message: { content: { file, type, profile } }, trackingProperties, source }) {
        const url = await this.ApplicationService2.uploadFile(file, { type, profile });
        const messageResponse = {
            response: url,
            trackingProperties,
        };
        source.postMessage(messageResponse, '*');
    }
}
